import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-font-awesome-sizes',
	templateUrl:'./FontAwesomeSizesPluginCompPage.html',
	styles: [],
	styleUrls:['./FontAwesomeSizesPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class FontAwesomeSizesPluginCompPage
{
	mdContent_956 = `\`\`\`java
import com.jwebmp.plugins.fontawesome5.options.FontAwesomeSizes;
\`\`\``;
}
